/* global $, prestashop */

$(document).ready(() => {
    console.log('auth');

    $(document).on('change', 'input[name="pro"]', (e) => {
        const pro = parseInt($(e.currentTarget).val());

        $(e.currentTarget).closest('.form-group').nextAll().each((index, el) => {
            const $el = $(el);

            if ($el.attr('name') === 'pro-end') {
                $el.prop('disabled', !pro);

                return false;
            }

            $el.find('input, select').prop('disabled', !pro);

            if (pro) {
                $el.slideDown();
            } else {
                $el.slideUp();
            }
        });
    });

    $('input[name="pro"]:checked').trigger('change');

    $(document).on('change', 'input[name="account_use_same_address"]', (e) => {
        const account_use_same_address = parseInt($(e.currentTarget).val());

        $(e.currentTarget).closest('.form-group').nextAll().each((index, el) => {
            const $el = $(el);

            if ($el.attr('name') === 'account_use_same_address-end') {
                $el.prop('disabled', account_use_same_address);

                return false;
            }

            $el.find('input, select').prop('disabled', account_use_same_address);

            if (!account_use_same_address) {
                $el.slideDown();
            } else {
                $el.slideUp();
            }
        });
    });

    $('input[name="account_use_same_address"]:checked').trigger('change');
});
